{
  "SEARCH": {
    "TABS": {
      "ALL": "Всі",
      "CONTACTS": "Контакти",
      "CONVERSATIONS": "Бесіди",
      "MESSAGES": "Текст повідомлень"
    },
    "SECTION": {
      "CONTACTS": "Контакти",
      "CONVERSATIONS": "Бесіди",
      "MESSAGES": "Текст повідомлень"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "Шукаємо",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "На запит '{query} не знайдено {item}",
    "EMPTY_STATE_FULL": "Немає результатів за запитом '{query}",
    "PLACEHOLDER_KEYBINDING": "/ фокус",
    "INPUT_PLACEHOLDER": "Введіть 3 або більше символів для пошуку",
    "EMPTY_STATE_DEFAULT": "Пошук бесід по id, email, тел. номеру, повідомлень для кращого пошуку результатів. ",
    "BOT_LABEL": "Бот",
    "READ_MORE": "Детальніше",
    "WROTE": "написав(ла):",
    "FROM": "від",
    "EMAIL": "email",
    "EMAIL_SUBJECT": "тема",
    "RECENT_MESSAGES": "Мої нещодавно надіслані повідомлення"
  }
}
